import { atom } from 'jotai'
import { OrgAssets } from '../../views'

export const orgAssetsAtom = atom<OrgAssets>({
	media: [],
})
